import { NgModule } from '@angular/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsModule } from '@ngxs/store';
import {
  BagMiscellaneousState,
  BagPieceState,
  BagsListState,
  BagInformationState,
  BagInfoState,
  PieceBagState,
  BagDropdownsListState,
} from '../features/components/bag/store/bag.state';
import {
  RolesState,
  DispCodesState,
  PODState,
  MiscellaneousState,
  HawbInformationState,
  CommodityState,
  MiscellaneousCommodityState,
  HawbsListState,
  ConsigneeShippingState,
  HawbDropdownsListState,
  PieceState,
  HawbRoutesState,
} from '../features/components/hawb/store/hawb.state';
import { ResetAllState } from '../features/components/hawb/store/reset.states';
import { NotesSectionState } from './components/notes/store/notes.state';
import { AttachmentState } from './components/attachments/store/attachments.state';
import { EventsState } from './components/events/store/events.state';
import { BagResetAllState } from '../features/components/bag/store/reset.states';
import {
  EventsManifestState,
  ManifestBagListState,
  ManifestDetailsState,
  ManifestDropdownsListState,
  ManifestInformationState,
  ManifestsListState,
} from '../features/components/manifest/store/manifest.state';
import { ManifestResetAllState } from '../features/components/manifest/store/reset.states';
import {
  FlightMiscellaneousState,
  FlightState,
  ManifestsMawbState,
  MawbDetailsState,
  MawbDropdownsListState,
  MawbInformationState,
  MawbManifestState,
  MawbMiscellaneousState,
  MawbsListState,
} from '../features/components/mawb/store/mawb.state';
import { MawbResetAllState } from '../features/components/mawb/store/mawb.reset';
import {
  AttachmentAdvanceSearchModalState,
  BagAdvanceModalState,
  CommodityAdvanceModalState,
  ConsigneeAdvanceModalState,
  CrudAdvanceModalState,
  DetailAdvanceModalState,
  ManifestAdvanceModalState,
  MawbAdvanceModalState,
  MiscAdvanceState,
  NoteAdvanceModalState,
  ResetHawbAdvanceSearchState,
  RoleAdvanceModalState,
  StatusAdvanceModalState,
  RoutingAdvanceModalState,
  WidgetAdvanceState,
} from './components/advanced-search/store/advance-search.state';
import {
  AccountDropdownsListState,
  AccountInformationState,
  AccountListState,
  AccountsAddressInfoState,
  AccountsBusinessInfoState,
  AccountsCustomerManagementState,
  AccountsDetailState,
  AccountsGovernmentInfoState,
  AccountUserState,
} from '../features/components/accounts/store/accounts.state';
import { AccountsResetAllState } from '../features/components/accounts/store/reset.state';
import {
  UsersDepartmentsInfoState,
  UsersListState,
  UserInformationState,
} from '../features/components/user-management/store/user.state';
import {
  FieldsAndTabsState,
  RoleInformationState,
  RolesAndPermissionPageSelectionState,
  RolesAndPermissionsListState,
} from '../features/components/roles-and-permissions/store/roles-permissions.state';
import { StatusCodesListState } from '../features/components/status-codes/store/status-codes.state';
import {
  NumberInformationState,
  NumberRangesListState,
} from '../features/components/number-ranges/store/number.state';
import {
  CustomsCityAbiState,
  CustomsCityDraftState,
  FullmanFileListState,
} from '../features/components/smDashboard/fullman-upload/store/fullman-upload.state';
import {
  AgentInformationState,
  AgentSummaryState,
} from '../features/components/agents/store';
import { UserEffectivePermissionsState } from '../features/store/user-effective-permissions/user-effective-permissions.state';

@NgModule({
  imports: [
    NgxsModule.forRoot([
      BagMiscellaneousState,
      BagPieceState,
      RolesState,
      DispCodesState,
      PODState,
      AttachmentState,
      MiscellaneousState,
      HawbInformationState,
      CommodityState,
      PieceState,
      MiscellaneousCommodityState,
      ResetAllState,
      BagResetAllState,
      EventsState,
      HawbsListState,
      ManifestsListState,
      BagsListState,
      BagInformationState,
      BagInfoState,
      PieceBagState,
      NotesSectionState,
      ManifestDetailsState,
      ManifestBagListState,
      ManifestResetAllState,
      ManifestInformationState,
      MawbDetailsState,
      MawbMiscellaneousState,
      MawbManifestState,
      FlightState,
      MawbsListState,
      ConsigneeShippingState,
      MawbResetAllState,
      FlightMiscellaneousState,
      MawbInformationState,
      ManifestsMawbState,
      WidgetAdvanceState,
      AttachmentAdvanceSearchModalState,
      DetailAdvanceModalState,
      CommodityAdvanceModalState,
      RoleAdvanceModalState,
      NoteAdvanceModalState,
      CrudAdvanceModalState,
      BagAdvanceModalState,
      ManifestAdvanceModalState,
      MawbAdvanceModalState,
      ConsigneeAdvanceModalState,
      StatusAdvanceModalState,
      RoutingAdvanceModalState,
      MiscAdvanceState,
      ResetHawbAdvanceSearchState,
      AccountsDetailState, // S&M - Accounts
      AccountsAddressInfoState,
      AccountsBusinessInfoState,
      AccountsCustomerManagementState,
      AccountsGovernmentInfoState,
      AccountListState,
      AccountInformationState,
      AccountsResetAllState,
      UsersListState, // S&M - Users
      UsersDepartmentsInfoState,
      UserInformationState,
      FieldsAndTabsState, // Roles & Permissions
      RolesAndPermissionPageSelectionState,
      RoleInformationState,
      RolesAndPermissionsListState,
      StatusCodesListState, //Status Code
      HawbDropdownsListState,
      NumberRangesListState,
      NumberInformationState,
      ManifestDropdownsListState,
      BagDropdownsListState,
      MawbDropdownsListState,
      AccountDropdownsListState,
      AccountUserState,
      FullmanFileListState,
      CustomsCityDraftState,
      CustomsCityAbiState,
      EventsManifestState,
      AgentSummaryState,
      AgentInformationState,
      HawbRoutesState,
      UserEffectivePermissionsState,
    ]),
    NgxsLoggerPluginModule.forRoot(),
    NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  providers: [],
})
export class StoreModule {}
